import { render } from "./CallUsModal.vue?vue&type=template&id=b9484a2c"
import script from "./CallUsModal.vue?vue&type=script&lang=js"
export * from "./CallUsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__